module.exports = __webpack_public_path__ + "static/media/24_7.e2b36b4e.png";